
import Component from "vue-class-component"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import SsComponentPage from "@/report/pages/SsComponentPage.vue"
import InvestmentApproachChart from "@/superannuation/InvestmentApproachChart.vue"

@Component({
  name: "SsInvestmentPage",
  components: {
    SsComponentPage,
    InvestmentApproachChart,
  },
})
export default class SsInvestmentPage extends AbstractPage {}
